export default function(str) {
  let val
  try {
    val = JSON.parse(str)
  } catch {
    return str
  }
  return val
}
